/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import {  Routes, Route } from 'react-router-dom'
import slugify from 'slugify'

import { Header } from './components/Header'
import { faker } from '@faker-js/faker'
import { players } from './assets/data'
import './App.css'
import { PlayerDetails } from './components/PlayerDetails'
import { Player } from './assets/data'
import Home from './components/Home'

function App() {
  const [playerArray, setPlayersArray] = useState(players)
  const [newImages, setNewImages] = useState([])
  const [details,setDetails] = useState(null as null|Player)

  // console.log(newPlayerImages)

  useEffect(() => {
    async function fetchImages() {
    

      const response = await fetch('https://randomuser.me/api/?results=100&inc=picture&gender=male')
      const results = (await response.json()).results.map((i: any) => i.picture.large)
      const uniqueImages = results.filter((e:any, i:any) => results.indexOf(e) === i)
      setNewImages(uniqueImages)
    }
    fetchImages()
    playerArray.forEach((player) => {
      if (!player.stats.wins) player.stats.wins = faker.number.int({ max: 10000 })
      if (!player.stats.losses) player.stats.losses = faker.number.int({ max: 10000 })
    })
    setPlayersArray(playerArray)
  }, [])
  useEffect(() => {
    const tempArray: Player[] = []
    newImages.forEach((image: any) => {
      const name = faker.person.fullName({ sex: 'male' })
      const wins = faker.number.int({max:10000})
      const losses = faker.number.int({ max: 10000 })
      tempArray.push({ image, name, stats: { wins, losses } })
    })
    setPlayersArray(players.concat(tempArray).sort(() => Math.random() - 0.5))
  }, [newImages])
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route index element={<Home players={playerArray} setDetails={setDetails} />} />
        <Route path="/" element={<Home players={playerArray} setDetails={setDetails} />} />
        <Route path={slugify(details?.name||'')} element={details && <PlayerDetails player={details} setDetails={setDetails} />} />
      </Routes>
    </div>
  )
}

export default App
